import { render } from "./GmailAuthStatusBar.vue?vue&type=template&id=07891ff0"
import script from "./GmailAuthStatusBar.vue?vue&type=script&lang=js"
export * from "./GmailAuthStatusBar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__